export function formatCampaignEventData(data = {}) {
  const formattedData = { ...data }
  const eventSuffix = formattedData.identifier || formattedData.category
  if (eventSuffix) {
    formattedData.eventSuffix = `: ${eventSuffix}`
    delete formattedData.identifier
    delete formattedData.category
  }
  return formattedData
}
